import React from 'react';
import styles from './VotingSession.module.css';
import classNames from 'classnames';

export const PokerCard = ({
  value,
  cardColor,
  cardSize,
  onClick,
}: {
  value: string;
  cardColor: 'normal' | 'selected' | 'submitted';
  cardSize: 'normal' | 'small';
  onClick?: (option: string) => void;
}) => {
  const cardText = value.length ? value : '?';
  const cornerText = value.length ? value.slice(0, 2) : '?';
  return (
    <div
      className={classNames(
        styles.pokerCardOuter,
        onClick && styles.pokerCardIsButton,
        cardSize === 'small' && styles.pokerCardSmallVersion,
        cardColor === 'selected' && styles.pokerCardIsSelected,
        cardColor === 'submitted' && styles.pokerCardIsSubmitted
      )}
      onClick={() => onClick && onClick(value)}
    >
      <div className={styles.pokerCardInner}>
        <div
          className={classNames(
            styles.pokerCardDot,
            styles.pokerCardDotTopLeft
          )}
        >
          {cornerText}
        </div>
        <div
          className={classNames(
            styles.pokerCardDot,
            styles.pokerCardDotBottomRight
          )}
        >
          {cornerText}
        </div>
        <div className={styles.pokerCardContent}>{cardText}</div>
      </div>
    </div>
  );
};
